const setArrayValues = item => {
  return item.values[0]?.id ? item.values.map(val => val.id) : item.values;
};

const generateValues = item => {
  const { values, inputType, attribute_key } = item;

  if (!values) {
    return [];
  }

  if (typeof values === 'object' && inputType === 'date_range') {
    return values;
  }

  if (inputType === 'comma_separated_plain_text') {
    return [values];
  }

  if (attribute_key === 'content') {
    return values?.split(',') || '';
  }

  if (Array.isArray(values)) {
    return setArrayValues(item);
  }

  if (typeof values === 'object') {
    return [values.id];
  }

  return [values];
};

const generatePayload = data => {
  // Make a copy of data to avoid vue data reactivity issues
  const filters = JSON.parse(JSON.stringify(data));
  let payload = filters.map(item => {
    // If item key is content, we will split it using comma and return as array
    // FIX ME: Make this generic option instead of using the key directly here
    item.values = generateValues(item);
    return item;
  });

  // For every query added, the query_operator is set default to and so the
  // last query will have an extra query_operator, this would break the api.
  // Setting this to null for all query payload
  payload[payload.length - 1].query_operator = undefined;
  return { payload };
};

export default generatePayload;
